import { render, staticRenderFns } from "./PalletDetail.vue?vue&type=template&id=c3e15ca6&scoped=true"
import script from "./PalletDetail.vue?vue&type=script&lang=js"
export * from "./PalletDetail.vue?vue&type=script&lang=js"
import style0 from "./PalletDetail.vue?vue&type=style&index=0&id=c3e15ca6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e15ca6",
  null
  
)

export default component.exports